import { render, staticRenderFns } from "./show-review-cards.vue?vue&type=template&id=eb8db8bc&"
import script from "./show-review-cards.vue?vue&type=script&lang=ts&"
export * from "./show-review-cards.vue?vue&type=script&lang=ts&"
import style0 from "./show-review-cards.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
